<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加主题活动</el-button
          >
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="活动标题"
            prop="title"
            width="200"
            align="center"
          />
          <el-table-column label="活动图片" width="160" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 80px; height: 45px"
                :src="scope.row.image"
                fit="cover"
                :preview-src-list="[scope.row.image]"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="宝箱ID"
            prop="box_goods_id"
            width="130"
            align="center"
          />
          <el-table-column label="状态" width="180" align="center">
            <template slot-scope="scope">
              <!-- PC 端 -->
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                active-text="上架"
                inactive-text="下架"
                @change="handleChangeStatus(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            align="center"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            align="center"
          />

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            fixed="right"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-s-goods"
                @click.stop="openThemeGoodsDialog(scope.row)"
                >商品</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加主题活动' : '编辑主题活动'"
          :visible.sync="pcDialogVisible"
          width="580px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="formRules"
            ref="pcFormRef"
            label-width="110px"
          >
            <el-form-item label="活动标题" prop="title">
              <el-input
                v-model="pcForm.title"
                placeholder="请输入活动标题"
                style="width: 360px"
              />
            </el-form-item>

            <el-form-item label="活动图片" prop="image">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-input
                  v-model="pcForm.image"
                  placeholder="选择图片后自动填充"
                  style="width: 280px"
                  readonly
                />
                <el-button @click="openImageSelectDialog('pc')"
                  >选择图片</el-button
                >
              </div>
              <div v-if="pcForm.image" style="margin-top: 8px">
                <el-image
                  :src="pcForm.image"
                  style="width: 120px; height: 60px"
                  fit="cover"
                  :preview-src-list="[pcForm.image]"
                />
              </div>
            </el-form-item>

            <el-form-item label="宝箱ID" prop="box_goods_id">
              <el-input
                v-model.number="pcForm.box_goods_id"
                placeholder="请输入盲盒ID"
                style="width: 360px"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加主题活动</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info">
                <div class="title">标题：{{ item.title }}</div>
                <div class="meta">ID:{{ item.id }}</div>
              </div>
              <el-switch
                v-model="item.status"
                :active-value="1"
                :inactive-value="0"
                
                size="mini"
                @change="handleChangeStatus(item)"
              />
            </div>
            <div class="card-body">
              <div style="margin: 6px 0">
                <el-image
                  style="width: 100px; height: 50px"
                  :src="item.image"
                  fit="cover"
                  :preview-src-list="[item.image]"
                />
              </div>
              <div>宝箱ID：{{ item.box_goods_id }}</div>
              <div>创建时间：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <!-- <el-button
                size="mini"
                type="info"
                round
                @click.stop="openThemeGoodsDialog(item)"
              >商品</el-button> -->
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端添加/编辑弹窗 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加主题活动' : '编辑主题活动'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="formRules"
            ref="mobileFormRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="活动标题" prop="title">
              <el-input
                v-model="mobileForm.title"
                placeholder="请输入活动标题"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="活动图片" prop="image">
              <el-input
                v-model="mobileForm.image"
                placeholder="点击下方按钮选择图片"
                readonly
              />
              <el-button
                size="small"
                @click="openImageSelectDialog('mobile')"
                style="margin-top: 6px"
                >选择图片</el-button
              >
              <div v-if="mobileForm.image" style="margin-top: 8px">
                <el-image
                  :src="mobileForm.image"
                  style="width: 100px; height: 50px"
                  fit="cover"
                  :preview-src-list="[mobileForm.image]"
                />
              </div>
            </el-form-item>
            <el-form-item label="宝箱ID" prop="box_goods_id">
              <el-input
                v-model.number="mobileForm.box_goods_id"
                placeholder="请输入盲盒ID"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="mobileSubmitForm"
              >保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- 图片选择弹窗（公共弹窗） -->
    <el-dialog
      title="选择活动图片"
      :visible.sync="imageDialogVisible"
      width="70%"
      append-to-body
    >
      <div class="image-list-wrap" v-loading="imageLoading">
        <div class="image-grid">
          <div
            class="image-item"
            v-for="img in imageList"
            :key="img.id"
            @click="selectImage(img.url)"
          >
            <el-image :src="img.url" fit="cover" />
          </div>
        </div>
      </div>
      <el-pagination
        style="margin-top: 16px; text-align: right"
        @current-change="handleImagePageChange"
        :current-page="imageSearch.page"
        :page-size="imageSearch.page_size"
        :total="imagePageInfo.total"
        layout="prev, pager, next"
      />
      <div slot="footer">
        <el-button @click="imageDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 主题商品弹窗 -->
    <el-dialog
      title="主题绑定商品管理"
      :visible.sync="themeGoodsDialogVisible"
      width="80%"
      append-to-body
    >
      <div
        style="
          margin-bottom: 12px;
          display: flex;
          gap: 10px;
          align-items: center;
        "
      >
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="openGoodsSelectDialog"
          >添加商品</el-button
        >
      </div>

      <!-- 待提交临时商品列表【带图片+文字类型展示】 -->
      <div style="margin-bottom: 25px">
        <p style="font-weight: bold; margin-bottom: 8px">待提交商品</p>
        <div v-loading="themeGoodsLoading" element-loading-text="加载中...">
          <el-table
            :data="tempThemeGoodsList"
            border
            stripe
            size="small"
            style="width: 100%"
          >
            <el-table-column label="赏品图片" width="110" align="center">
              <template #default="scope">
                <el-image
                  :src="scope.row.image"
                  style="width: 70px; height: 45px"
                  fit="cover"
                  :preview-src-list="[scope.row.image]"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="商品ID"
              prop="goods_id"
              width="120"
              align="center"
            />
            <el-table-column label="售价" width="140" align="center">
              <template #default="scope">
                <el-input
                  v-model="scope.row.price"
                  size="mini"
                  style="width: 100px"
                  placeholder="售价"
                  @input="
                    scope.row.price = scope.row.price.replace(/[^\d.]/g, '')
                  "
                  @blur="formatTwoDecimal(scope.row, 'price')"
                />
              </template>
            </el-table-column>
            <el-table-column label="回收价" width="140" align="center">
              <template #default="scope">
                <el-input
                  v-model="scope.row.recovery_price"
                  size="mini"
                  style="width: 100px"
                  placeholder="回收价"
                  @input="
                    scope.row.recovery_price = scope.row.recovery_price.replace(
                      /[^\d.]/g,
                      ''
                    )
                  "
                  @blur="formatTwoDecimal(scope.row, 'recovery_price')"
                />
              </template>
            </el-table-column>
            <el-table-column label="赏品类型" width="160" align="center">
              <template #default="scope">
                <span>{{ scope.row.type_name }}</span>
                <!-- 隐藏存储用的goods_type数字，仅展示文字 -->
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template #default="scope">
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="delTempThemeGoods(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 数据库已绑定商品列表【严格匹配接口返回字段】 -->
      <div>
        <p style="font-weight: bold; margin-bottom: 8px">
          已绑定商品列表（数据库）
        </p>
        <div v-loading="themeGoodsLoading" element-loading-text="加载中...">
          <el-table
            :data="themeGoodsList"
            border
            stripe
            size="small"
            style="width: 100%"
          >
            <el-table-column label="ID" prop="id" width="70" align="center" />
            <el-table-column
              label="商品ID"
              prop="goods_id"
              width="100"
              align="center"
            />
            <el-table-column
              label="商品名称"
              prop="goods_name"
              min-width="160"
            />
            <el-table-column label="商品图" width="100" align="center">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.goods_image"
                  style="width: 60px; height: 40px"
                  fit="cover"
                  :preview-src-list="[scope.row.goods_image]"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="售价"
              prop="price"
              width="100"
              align="center"
            />
            <el-table-column
              label="回收价"
              prop="recovery_price"
              width="100"
              align="center"
            />
            <el-table-column
              label="商品类型"
              prop="goods_type"
              width="100"
              align="center"
            />
            <el-table-column
              label="创建时间"
              prop="created_at"
              width="180"
              align="center"
            />
            <el-table-column
              label="更新时间"
              prop="updated_at"
              width="180"
              align="center"
            />
            <el-table-column
              label="操作"
              width="140"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <!-- <el-button type="text" icon="el-icon-edit" @click="openEditThemeGoodsDialog(scope.row)">编辑</el-button> -->
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  style="color: #f56c6c"
                  @click="delThemeGoods(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            style="margin-top: 16px; text-align: right"
            @current-change="handleThemeGoodsPage"
            :current-page="themeGoodsSearch.page"
            :page-size="themeGoodsSearch.page_size"
            :total="themeGoodsPageInfo.total"
            layout="total,prev,pager,next"
          />
        </div>
      </div>

      <div
        slot="footer"
        style="
          text-align: right;
          gap: 10px;
          display: flex;
          justify-content: flex-end;
        "
      >
        <el-button @click="themeGoodsDialogVisible = false">关闭</el-button>
        <el-button
          type="primary"
          @click="submitAllThemeGoods"
          :loading="submitThemeGoodsLoading"
          >确认提交全部商品</el-button
        >
      </div>

      <!-- 商品库选择弹窗【单选模式】 -->
      <el-dialog
        title="选择商品库商品"
        :visible.sync="goodsSelectDialogVisible"
        width="80%"
        append-to-body
      >
        <div
          class="goods-search-bar"
          style="
            display: flex;
            gap: 10px;
            align-items: center;
            margin-bottom: 12px;
          "
        >
          <el-input
            v-model="goodsSearch.title"
            placeholder="商品名称"
            style="width: 200px"
            clearable
          />
          <el-input
            v-model.number="goodsSearch.type"
            placeholder="商品类型"
            style="width: 120px"
            clearable
          />
          <el-input
            v-model.number="goodsSearch.level_id"
            placeholder="等级ID"
            style="width: 120px"
            clearable
          />
          <el-input
            v-model.number="goodsSearch.flag"
            placeholder="标识"
            style="width: 100px"
            clearable
          />
          <el-button type="primary" @click="getGoodsList">查询</el-button>
        </div>
        <el-table
          :data="goodsList"
          border
          stripe
          v-loading="goodsLoading"
          style="width: 100%"
          highlight-current-row
          @row-click="handleSelectSingleGoods"
        >
          <el-table-column label="选择" width="70" align="center">
            <template slot-scope="scope">
              <el-radio
                v-model="currentSelectGoodsId"
                :label="scope.row.id"
                @click.stop
              />
            </template>
          </el-table-column>
          <el-table-column
            label="商品ID"
            prop="id"
            width="100"
            align="center"
          />
          <el-table-column
            label="商品名称"
            prop="title"
            align="center"
            min-width="160"
          />
          <el-table-column label="商品图" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                :src="scope.row.image"
                style="width: 60px; height: 40px"
                fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="类型"
            prop="type_name"
            width="120"
            align="center"
          />
          <el-table-column
            label="等级"
            prop="level_name"
            width="120"
            align="center"
          />
          <el-table-column label="标识" prop="flag" width="80" align="center" />
        </el-table>
        <el-pagination
          style="margin-top: 16px; text-align: right"
          @current-change="handleGoodsPage"
          :current-page="goodsSearch.page"
          :page-size="goodsSearch.page_size"
          :total="goodsPageInfo.total"
          layout="total,prev,pager,next"
        />
        <div slot="footer">
          <el-button @click="goodsSelectDialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click="addSingleGoodsToTemp"
            :disabled="!currentSelectGoodsId"
            >确认添加选中商品</el-button
          >
        </div>
      </el-dialog>

      <!-- 编辑已绑定商品弹窗【精简仅保留指定4个参数】 -->
      <el-dialog
        title="编辑绑定商品"
        :visible.sync="editThemeGoodsDialogVisible"
        width="500px"
        append-to-body
      >
        <el-form
          :model="editThemeGoodsForm"
          ref="editThemeGoodsRef"
          label-width="120px"
        >
          <el-form-item label="商品ID">
            <el-input v-model.number="editThemeGoodsForm.goods_id" readonly />
          </el-form-item>
          <el-form-item label="售价" prop="price">
            <el-input
              v-model="editThemeGoodsForm.price"
              placeholder="请输入售价"
            />
          </el-form-item>
          <el-form-item label="回收价" prop="recovery_price">
            <el-input
              v-model="editThemeGoodsForm.recovery_price"
              placeholder="请输入回收价"
            />
          </el-form-item>
          <el-form-item label="商品类型" prop="goods_type">
            <el-input
              v-model.number="editThemeGoodsForm.goods_type"
              placeholder="请输入商品类型数字"
            />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editThemeGoodsDialogVisible = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="submitEditThemeGoods"
            :loading="editThemeGoodsLoading"
            >确认保存</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "ThemeActivity",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
      },
      formRules: {
        title: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
        image: [
          { required: true, message: "请选择活动图片", trigger: "change" },
        ],
        box_goods_id: [
          { required: true, message: "请输入盲盒ID", trigger: "blur" },
          { type: "number", message: "盲盒ID必须为数字", trigger: "blur" },
        ],
      },

      // PC弹窗
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        theme_id: "",
        title: "",
        image: "",
        box_goods_id: "",
      },

      // 移动端弹窗
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        theme_id: "",
        title: "",
        image: "",
        box_goods_id: "",
      },

      // 图片选择弹窗
      imageDialogVisible: false,
      imageLoading: false,
      imageTarget: "pc",
      imageList: [],
      imagePageInfo: { total: 0 },
      imageSearch: {
        page: 1,
        page_size: 10,
        type: 1,
      },

      // 主题商品管理
      themeGoodsDialogVisible: false,
      currentThemeId: "",
      themeGoodsLoading: false,
      submitThemeGoodsLoading: false,
      editThemeGoodsLoading: false,
      themeGoodsList: [],
      tempThemeGoodsList: [],
      themeGoodsPageInfo: { total: 0 },
      themeGoodsSearch: {
        page: 1,
        page_size: 15,
      },
      addedGoodsIds: [],

      // 商品库选择弹窗（单选）
      goodsSelectDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsPageInfo: { total: 0 },
      goodsSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: "",
      },
      currentSelectGoodsId: null,

      // 编辑弹窗
      editThemeGoodsDialogVisible: false,
      editThemeGoodsForm: {
        id: "",
        theme_id: "",
        goods_id: "",
        price: "",
        recovery_price: "",
        goods_type: "",
      },
      addThemeGoodsRules: {
        goods_id: [{ required: true, message: "请选择商品", trigger: "blur" }],
        price: [{ required: true, message: "请输入售价", trigger: "blur" }],
        recovery_price: [
          { required: true, message: "请输入回收价", trigger: "blur" },
        ],
        goods_type: [
          { required: true, message: "请输入商品类型", trigger: "blur" },
          { type: "number", message: "类型为数字", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getThemeList();
  },
  methods: {
    // 小数格式化
    formatTwoDecimal(row, field) {
      let val = parseFloat(row[field] || 0);
      row[field] = val.toFixed(6);
    },

    // 主题列表
    getThemeList() {
      this.loading = true;
      api.theme
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 图片选择
    openImageSelectDialog(target) {
      this.imageTarget = target;
      this.imageSearch.page = 1;
      this.getImageList();
      this.imageDialogVisible = true;
    },
    getImageList() {
      this.imageLoading = true;
      api.images
        .index({ params: this.imageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.imageList = res.data.data.data;
            this.imagePageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.imageLoading = false;
        });
    },
    handleImagePageChange(page) {
      this.imageSearch.page = page;
      this.getImageList();
    },
    selectImage(url) {
      if (this.imageTarget === "pc") {
        this.pcForm.image = url;
      } else {
        this.mobileForm.image = url;
      }
      this.imageDialogVisible = false;
    },

    // 状态切换
    async handleChangeStatus(row) {
      this.loading = true;
      api.theme
        .status({
          theme_id: row.id,
          status: row.status,
        })
        .then((res) => {
          if (res.data.code == 1000) {
          } else {
            this.getThemeList();
          }
        })
        .catch(() => {
          this.getThemeList();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // PC 增改
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        theme_id: row.id,
        title: row.title,
        image: row.image,
        box_goods_id: row.box_goods_id,
      };
      this.pcDialogVisible = true;
    },
    pcResetForm() {
      this.pcForm = {
        theme_id: "",
        title: "",
        image: "",
        box_goods_id: "",
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        let reqApi;
        let params = { ...this.pcForm };
        if (this.pcDialogType === "add") {
          reqApi = api.theme.add;
          delete params.theme_id;
        } else {
          reqApi = api.theme.edit;
        }
        reqApi(params)
          .then((res) => {
            if (res.data.code === "1000") {
              this.pcDialogVisible = false;
              this.getThemeList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // 移动端增改
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        theme_id: row.id,
        title: row.title,
        image: row.image,
        box_goods_id: row.box_goods_id,
      };
      this.mobileDialogVisible = true;
    },
    mobileResetForm() {
      this.mobileForm = {
        theme_id: "",
        title: "",
        image: "",
        box_goods_id: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        let reqApi;
        let params = { ...this.mobileForm };
        if (this.mobileDialogType === "add") {
          reqApi = api.theme.add;
          delete params.theme_id;
        } else {
          reqApi = api.theme.edit;
        }
        reqApi(params)
          .then((res) => {
            if (res.data.code === "1000") {
              this.mobileDialogVisible = false;
              this.getThemeList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // 公共分页
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getThemeList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getThemeList();
    },

    // 主题商品弹窗
    openThemeGoodsDialog(row) {
      if (this.currentThemeId != row.id) {
        this.tempThemeGoodsList = [];
        this.addedGoodsIds = [];
      }
      this.currentThemeId = row.id;
      this.themeGoodsSearch.page = 1;
      this.themeGoodsDialogVisible = true;
      this.getThemeGoodsList();
    },
    getThemeGoodsList() {
      this.themeGoodsLoading = true;
      api.theme
        .themeGoodsList({
          params: {
            theme_id: this.currentThemeId,
            ...this.themeGoodsSearch,
          },
        })
        .then((res) => {
          if (res.data.code == "1000") {
            this.themeGoodsList = res.data.data.data || [];
            this.themeGoodsPageInfo.total = res.data.data.total || 0;
          }
        })
        .finally(() => (this.themeGoodsLoading = false));
    },
    handleThemeGoodsPage(page) {
      this.themeGoodsSearch.page = page;
      this.getThemeGoodsList();
    },

    // 删除数据库商品
    async delThemeGoods(row) {
      try {
        await this.$confirm(`确定删除商品【${row.goods_name}】？`, "提示", {
          type: "warning",
        });
      } catch (e) {
        return;
      }
      this.themeGoodsLoading = true;
      api.theme
        .delThemeGoods({
          theme_id: this.currentThemeId,
          goods_id: row.goods_id,
        })
        .then((res) => {
          if (res.data.code == "1000") {
            this.getThemeGoodsList();
          }
        })
        .finally(() => (this.themeGoodsLoading = false));
    },

    // 商品库弹窗（单选）
    openGoodsSelectDialog() {
      this.goodsSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: "",
      };
      this.currentSelectGoodsId = null;
      this.getGoodsList();
      this.goodsSelectDialogVisible = true;
    },
    getGoodsList() {
      this.goodsLoading = true;
      api.goods
        .index({ params: this.goodsSearch })
        .then((res) => {
          if (res.data.code == "1000") {
            this.goodsList = res.data.data.data || [];
            this.goodsPageInfo.total = res.data.data.total || 0;
          }
        })
        .finally(() => (this.goodsLoading = false));
    },
    handleGoodsPage(page) {
      this.goodsSearch.page = page;
      this.getGoodsList();
    },
    // 点击行自动选中单选
    handleSelectSingleGoods(row) {
      this.currentSelectGoodsId = row.id;
    },
    // 添加单个商品至待提交列表
    addSingleGoodsToTemp() {
      const targetGoods = this.goodsList.find(
        (item) => item.id === this.currentSelectGoodsId
      );
      if (!targetGoods) return this.$message.warning("请选择商品");
      const exist = this.tempThemeGoodsList.some(
        (item) => item.goods_id == targetGoods.id
      );
      if (exist) return this.$message.warning("该商品已存在待提交列表");

      this.tempThemeGoodsList.push({
        goods_id: targetGoods.id,
        image: targetGoods.image,
        type_name: targetGoods.type_name,
        goods_type: targetGoods.goods_type,
        price: targetGoods.price || "0.00",
        recovery_price: targetGoods.price || "0.00",
      });
      if (!this.addedGoodsIds.includes(targetGoods.id))
        this.addedGoodsIds.push(targetGoods.id);

      this.goodsSelectDialogVisible = false;
      this.currentSelectGoodsId = null;
      this.$message.success("添加到待提交列表成功");
    },
    // 删除临时列表商品
    delTempThemeGoods(row) {
      this.tempThemeGoodsList = this.tempThemeGoodsList.filter(
        (i) => i.goods_id != row.goods_id
      );
      this.addedGoodsIds = this.addedGoodsIds.filter(
        (id) => id !== row.goods_id
      );
    },
    submitAllThemeGoods() {
      if (this.tempThemeGoodsList.length === 0)
        return this.$message.warning("请添加商品到待提交列表");
      this.submitThemeGoodsLoading = true;
      // 取第一条，组装单个对象，不再传数组
      const item = this.tempThemeGoodsList[0];
      const submitParams = {
        theme_id: this.currentThemeId,
        goods_id: item.goods_id,
        price: parseFloat(item.price),
        recovery_price: parseFloat(item.recovery_price),
        goods_type: item.goods_type,
      };
      api.theme
        .addThemeGoods(submitParams)
        .then((res) => {
          if (res.data.code == 1000) {
            this.tempThemeGoodsList = [];
            this.addedGoodsIds = [];
            this.currentSelectGoodsId = null;
            this.getThemeGoodsList();
          }
        })
        .finally(() => (this.submitThemeGoodsLoading = false));
    },

    // 编辑弹窗
    openEditThemeGoodsDialog(row) {
      this.editThemeGoodsForm = {
        id: row.id,
        theme_id: this.currentThemeId,
        goods_id: row.goods_id,
        price: row.price + "",
        recovery_price: row.recovery_price + "",
        goods_type: row.goods_type + "",
      };
      this.editThemeGoodsDialogVisible = true;
    },
    submitEditThemeGoods() {
      this.editThemeGoodsLoading = true;
      api.theme
        .editThemeGoods(this.editThemeGoodsForm)
        .then((res) => {
          if (res.data.code == 1000) {
            this.editThemeGoodsDialogVisible = false;
            this.getThemeGoodsList();
          }
        })
        .finally(() => (this.editThemeGoodsLoading = false));
    },
  },
};
</script>

<style scoped>
/* PC通用 */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端卡片 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

/* 图片选择弹窗样式 */
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
}
.image-item {
  width: 100%;
  height: 90px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}
.image-item >>> .el-image {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/theme/index.vue